module.exports = "/assets/data/1cfe2f621ecc2d9a42796b7abb5cbb41-EC2P.data.json";